import builder from '../builder';
import Bin1 from '../../streamline-icons/light/bin-1.svg';

export default builder('IconBin1Light', Bin1);
